import React, { useEffect } from "react";
import { Button, Form, Flex, Row, Col, Input, Checkbox } from "antd";
import { useForm } from "antd/es/form/Form";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { getAnnouncementState } from "../redux/store/getState";
import { IconPrimary, Popup } from "../components";
import { usePopup } from "../hooks/usePopup";
import { EditIcon } from "../assets";
import { User } from "../redux/apiSlice/userSlice";
import { updateAtcUser } from "../redux/apiActions/userActions";
import useUser from "../hooks/useUser";

type Props = {
  record?: User;
};

const ATCUserForm: React.FC<Props> = ({ record }: Props) => {
  const [form] = useForm();
  const popup = usePopup();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(getAnnouncementState);
  const { user } = useUser();

  const onFinish = async (data: any) => {
    let permissions;

    const _permissions: string[] = Object.entries(
      form.getFieldValue("permissions") || {}
    )
      .flatMap(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) {
          return values.map((value) => `${key}.${value}`);
        }
        return null;
      })
      .filter((item): item is string => Boolean(item));

    permissions = [..._permissions, "student"];

    const payload = { ...record, ...data, permissions };

    if (record?.id && user?.atc.id) {
      dispatch(
        updateAtcUser({
          data: payload,
          popup,
          user_id: record?.id,
          atc_id: user.atc.id,
        })
      );
    }
  };

  useEffect(() => {
    if (record) {
      const permissions: any = {};
      if (Array.isArray(record.permissions)) {
        record.permissions.forEach((permission: string) => {
          const keyValueArray = permission.split(".");

          if (keyValueArray?.length > 1) {
            if (permissions[keyValueArray[0]]?.length > 0)
              permissions[keyValueArray[0]].push(keyValueArray[1]);
            else {
              permissions[keyValueArray[0]] = [];
              permissions[keyValueArray[0]].push(keyValueArray[1]);
            }
          }
        });
      }

      form.setFieldsValue(record);
      form.setFieldValue("permissions", permissions);
    }
    return () => form.resetFields();
  }, [record, form]);

  return (
    <Popup
      ref={popup.popupRef}
      openTrigger={
        <IconPrimary>
          <EditIcon />
        </IconPrimary>
      }
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        className="user_form"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Username is required" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Email is required" }]}
        >
          <Input />
        </Form.Item>

        <Row>
          <Col span={6}>
            <Form.Item name="banned" valuePropName="checked">
              <Checkbox>Banned</Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Flex justify={"center"} style={{ marginTop: 40 }}>
          <Form.Item>
            <Button
              htmlType="submit"
              ghost
              disabled={loading.addAnnouncement || loading.updateAnnouncement}
              loading={loading.addAnnouncement || loading.updateAnnouncement}
            >
              Submit
            </Button>
          </Form.Item>
        </Flex>
      </Form>
    </Popup>
  );
};

export default ATCUserForm;
